// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"b0099494","453":"fd0f8c1d","693":"45ae6e7f","861":"49e160b6"}[chunkId] + ".chunk.js";
};